<template>
  <div class="rt-collapse-transition">
    <div class="rt-collapse-transition-header" @click="collapseClick">
      <rt-icon
        :name="showContent ? 'rt-base-angle_up' : 'rt-base-angle_down'"
        size="18"
        color="#143E81"
      />
      <p class="title">{{ title }}</p>
    </div>
    <el-collapse-transition>
      <div v-show="showContent" class="rt-collapse-transition-content">
        <slot />
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import ElCollapseTransition from '../../transitions/collapse-transition';
export default {
  name: 'RtCollapseTransition',
  components: {
    ElCollapseTransition
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showContent: this.show
    };
  },
  methods: {
    collapseClick(val) {
      this.showContent = !this.showContent;
    }
  }
};
</script>

<style lang="less">
.rt-collapse-transition {
  .rt-collapse-transition-header {
    display: flex;
    align-items: center;
    padding: 20px;
    .rt-icon {
      margin-right: 5px;
      margin-top: -2px;
    }
    .title {
      color: #143e81;
      font-size: 16px;
    }
  }
  .rt-collapse-transition-content {
    position: relative;
    padding: 20px;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: #e8ecfc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtCollapseTransition.vue?2a8403da